import { TLocoType } from 'shared/hooks/use-loco-translation'

export enum ContactsImportDelimiter {
  comma = ',',
  semicolon = ';',
  pipe = '|',
}

export const ContactsImportDelimiterNamesLocoKeys = {
  [ContactsImportDelimiter.comma]: 'dashboard.contact_import.form.delimiter.comma',
  [ContactsImportDelimiter.semicolon]: 'dashboard.contact_import.form.delimiter.semi_colon',
  [ContactsImportDelimiter.pipe]: 'dashboard.contact_import.form.delimiter.pipe',
}

export const getContactsImportDelimiterSelectOptions = (t: TLocoType) =>
  Object.entries(ContactsImportDelimiterNamesLocoKeys).map(([id, caption]) => ({
    id,
    caption: t(caption),
  })) as {
    id: ContactsImportDelimiter
    caption: typeof ContactsImportDelimiterNamesLocoKeys[ContactsImportDelimiter]
  }[]
